import { render, staticRenderFns } from "./historyMap.vue?vue&type=template&id=184e8a48&scoped=true"
import script from "./historyMap.vue?vue&type=script&lang=js"
export * from "./historyMap.vue?vue&type=script&lang=js"
import style0 from "./historyMap.vue?vue&type=style&index=0&id=184e8a48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184e8a48",
  null
  
)

export default component.exports